// @ts-nocheck
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import Minus from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus from "@store/Library/Components/Toolkit/Icons/Plus";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { filtersProps } from "@store/Themes/common/props/filters";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import accordion from "@store/Themes/common/styleguide/components/accordion";

const verticalPadding = pxToRem(16);
const horizontalPadding = pxToRem(20);
/* Store Custom Code - End */

const _headerButtonBaseStyles = () => {
    return css`
        /* Store Custom Code - Start */
        ${focusStyles()}
        position: relative;
        background-color: ${getColor("common.accent")};
        border: none;
        color: ${getColor("primary.light")};
        transition: ${transitionHoverStyles("color")};
        text-transform: uppercase;
        padding: ${verticalPadding} ${horizontalPadding};

        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.smaller};
            font-weight: ${theme.design.typography.weight.medium};
            border-radius: ${theme.design.radius.main};
            line-height: ${theme.design.typography.lineHeight.small};
            letter-spacing: ${theme.design.typography.letterSpacing.large};
        `}
        &[aria-expanded="true"] {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        &:hover {
            text-decoration: underline; /* Store Custom Code */
        }
        /* Store Custom Code - End */
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${x => focusStyles(`-${x.theme.focus.width}`)} // Store Custom Code
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

export const accordionFilterSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            ${_headerButtonStyles()}
            /* Store Custom Code - Remove transparency */

            ${AccordionSectionPanel} + && {
                ${_headerButtonStyles()}
                margin-top: ${pxToRem(10)}; /* Store Custom Code */
            }
        `,
    },
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: ${pxToRem(600)}; /* Store Custom Code */
            padding: ${horizontalPadding}; /* Store Custom Code */
            border: none;
            border-bottom: ${filtersProps.borderCss};
            /* Store Custom Code - Start */
            background-color: ${getColor("common.accent")};
            padding-top: calc(${horizontalPadding} - ${verticalPadding});
            /* Store Custom Code - End */
        `,
    },
    /* Store Custom Code - Start */
    toggleIconProps: {
        css: css`
            ${x => x.theme.accordion.sectionDefaultProps?.toggleIconProps?.css}
            width: ${pxToRem(24)};
        `,
    },
    /* Store Custom Code - End */
    collapseIconProps: {
        src: Minus,
    },
    expandIconProps: {
        src: Plus,
    },
};

export default accordion; // Store Custom Code
